/** Insert a space before each capital letter, e.g. `ProperCase` → `Proper Case`. */
export const addSpacesToProperCase = (s: string): string => s.replace(/([A-Z])/g, ' $1').trim();

/** Supplementary-plane pictographic characters (emoji) — unlike older BMP symbols (♦, ♔), these have no glyph coverage in the FastReport/GDI+ rendering font and print as squares. */
const emojiPattern = /[\u{1F000}-\u{10FFFF}]|\u{FE0F}|\u{200D}/gu;

/** Strip HTML markup, remove unsupported emoji, and normalize styled/compatibility Unicode (e.g. mathematical-alphanumeric "fancy text") to plain characters. */
export const cleanText = (str: string): string => {
    const doc = new DOMParser().parseFromString(str, 'text/html');
    const text = doc.body.textContent || '';
    return text.replace(emojiPattern, '').normalize('NFKC');
};

/** Translate a `{ value }` boolean-ish object to `'Yes'` / `'No'`. */
export const booleanTranslator = (paramValue: { value?: unknown } | null | undefined): string => {
    const value = Boolean(paramValue && paramValue.value);
    return value ? 'Yes' : 'No';
};
